module.exports = __webpack_public_path__ + "img/145.b5049e5b.jpg";